import React, { useCallback } from 'react';
import { InvalidTokenResult } from 'components/auth';
import { useNavigate } from 'react-router-dom';
import { WAREHOUSE_ROUTES } from '../../../../constants/routes';

export const InvalidResetToken: React.FC = () => {
  const navigate = useNavigate();

  const onButtonClick = useCallback(() => {
    navigate(WAREHOUSE_ROUTES.warehouseForgotPassword);
  }, [navigate]);

  return <InvalidTokenResult showButton={true} onButtonClick={onButtonClick} />;
};
